module.exports = __webpack_public_path__ + "img/chart-line-icon.ee1fedc4.svg";